import React from 'react'
import Link from 'gatsby-link'
import projects from '../global/data/projects'
import { Alert, Card, Icon, Avatar } from 'antd'
import userAvatar from "../global/assets/avatar.jpg"

const { Meta } = Card;





const OpenSource = ({ data }) => {

  return (
    <div className="page--open-source">

      <h1>These are Some of the Open Source projects I have worked on and contributed to.</h1>
      <p>You're free to use these projects as is, modify them and/or customize them according to your needs.</p>


      <div className="project--cards">
      { projects.map( project => {
        return (
          <Card
            key={ project.id }
            className="card--item"
            cover={ <div className="cover--image"></div> }
            actions={[
              <a href={ project.url } target="_blank"><Icon type="github" /> Open Project</a>,
              <a href={`${project.url} `} target="_blank"><Icon type="star" /> Repository</a>,
            ]}
          >
            <Meta
              avatar={<Avatar src={userAvatar} />}
              title={ project.title }
              description={ project.description }
            />
          </Card>
        )
      }) }
      </div>

      {/*
      <div className="component--projects-list">
      { projects.map( project => {
        return (
          <div key={ project.id } className="project">
            <h2><a href={ project.url } target="_blank">{ project.title }</a></h2>
            <p>{ project.description }</p>
          </div>
        )
      }) }
      </div>
      */}


    </div>
  );

}


export default OpenSource




// WEBPACK FOOTER //
// ./src/pages/open-source.js